var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseModal = function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.515 12.757a.9.9 0 0 0 0-1.272.9.9 0 0 0-1.272 0L17 15.727l-4.243-4.242a.9.9 0 0 0-1.272 0 .9.9 0 0 0 0 1.272L15.727 17l-4.242 4.243a.9.9 0 0 0 0 1.272.9.9 0 0 0 1.272 0L17 18.273l4.243 4.242a.9.9 0 0 0 1.272 0 .9.9 0 0 0 0-1.272L18.273 17z"
  })));
};
export default SvgCloseModal;